let AlertView = Backbone.View.extend({
	el: '.alert-view',
	events: {
		"click button": "close"
	},
	initialize() {
		this.template = JST.alertTpl;
	},
	render(data) {
		this.id = data.type;
		this.$el.html(this.template(data));
		this.$el.removeClass('hidden');
		return this.el;
	},
	close: function (e) {
		this.$el.addClass('hidden');
	}
});

export default AlertView;
